"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModuleStatus = exports.ErrorStatus = void 0;
var ModuleStatus = Object.freeze({
  /**
   * 初始化
   */
  INIT: 0,
  /**
   * 加载中
  */
  LOADING: 1,
  /**
   * 已下载未执行（懒执行函数）
   */
  WAITEXEC: 2,
  /**
   * 完成
  */
  COMPLETE: 3
});
exports.ModuleStatus = ModuleStatus;
var ErrorStatus = Object.freeze({
  /**
   * 没有错误
  */
  NONE: '',
  /**
   * 组件key对应的商店db信息不存在
  */
  DB: 'Component hub does not have the information of this component.',
  /**
   * 组件key对应的商店db cos请求失败
  */
  FILE: 'Component file request failed.',
  /**
   * 请求回来的组件实例，与发起的compKey不一致
  */
  NOTMATCH: 'The component instance returned by the request does not match the component key.',
  /**
   * 被标记为需要特殊加载的组件，但是对应的加载插件没有被注册
   */
  UNKNOWN_LOADER: 'The component needs to be loaded by a special loader, but the loader hasn\'t been registered.',
  /**
   * 加载失败
   */
  LOAD_FAIL: 'Component loading failed.'
});
exports.ErrorStatus = ErrorStatus;